import { filterSlots, findDateSlot, findTimeSlot } from '../helpers';

/**
 * Use selectDateSelectors instead
 */

export const selectSlotsByFilters = (slots, filters, eligibleSlotsFilter) =>
  filterSlots(slots, filters, eligibleSlotsFilter);

export const selectDateSlot = (slots, date) => {
  const dateSlots = slots.reduce((flattened, { dates }) => flattened.concat(dates), []);

  return findDateSlot(dateSlots, date);
};

export const selectTimeSlot = (selectedDateSlot, timeSlot) => {
  if (!selectedDateSlot) {
    return undefined;
  }

  return findTimeSlot(selectedDateSlot, timeSlot);
};

export const selectSlotMessages = (errors) =>
  errors.reduce(
    (setOfErrors, { type, id }) => ({
      ...setOfErrors,
      [type]: { id },
    }),
    {},
  );

export const calendarSelectors = {
  selectSlotsByFilters,
  selectDateSlot,
  selectTimeSlot,
  selectSlotMessages,
};
